import { Link } from "react-router-dom";
import { Button } from "@headlessui/react";

import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import { useState } from "react";

import { Radio, RadioGroup } from "@headlessui/react";

import store from "redux/store";
import { SHOW_MODAL_COMPANY_CONNECT_WITH_CODE } from "actions/types";

export default function DashboardForm({ ...data }) {
  //  let [errors, setErrors] = React.useState()
  //  let [saving, setSaving] = React.useState(false)
  //  let [name, setName] = React.useState(initialName);
  //  let [email, setEmail] = React.useState(initialEmail);
  const getUser = () => {
    let retVal = false;
    if (data.user && data.user && data.user.id > 0) {
      retVal = data.user;
    }
    return retVal;
  };

  const getCompany = () => {
    let retVal = false;
    if (data.user && data.user.company && data.user.company.id > 0) {
      retVal = data.user.company;
    }
    return retVal;
  };

  const changeCurrentCompany = (itemObj) => {
    const { setCurrentCompanyEvent } = data;
    setCurrentCompanyEvent(itemObj);
  };

  const addCompanyConnectCode = (event) => {
    event.preventDefault();
    store.dispatch({
      type: SHOW_MODAL_COMPANY_CONNECT_WITH_CODE,
      header: "Bedrijf koppelen",
      data: null,
      saveEvent: data.connectCompanyByCodeEvent,
    });
  };

  return (
    <>
      <div className="mb-4 md:flex md:items-center md:justify-between">
        <div className="flex-1 min-w-0">
          {getUser() && (
            <h2 className="font-bold text-gray-900 max-md:mb-3 text-2xl/7 sm:truncate sm:text-3xl sm:tracking-tight">
              Hallo, {getUser().full_name}
            </h2>
          )}
        </div>
        <div className="flex gap-2 mt-0 md:ml-4">
          <Link to="/profile/" className="btn-primary">
            Profiel bewerken
          </Link>
        </div>
      </div>
      <dl className="grid grid-cols-1 gap-5 pt-8 sm:grid-cols-2 xl:grid-cols-2">
        <Link
          to="/profile/"
          className="overflow-hidden relative px-4 pt-6 pb-12 bg-white border shadow-sm sm:px-6 sm:pt-7 group"
        >
          <dt>
            <div className="absolute p-3 rounded-full bg-primary/5">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                className="text-primary size-6"
                viewBox="0 0 24 24"
                fill="none"
              >
                <path
                  d="M6.11594 18.8103L5.46183 19.5667L6.11594 18.8103ZM17.8841 18.8103L17.23 18.0539L17.8841 18.8103ZM16.7618 19.0287L17.4364 19.7669L18.9128 18.4176L18.2382 17.6795L16.7618 19.0287ZM4 12C4 7.58172 7.58172 4 12 4V2C6.47715 2 2 6.47715 2 12H4ZM12 4C16.4183 4 20 7.58172 20 12H22C22 6.47715 17.5228 2 12 2V4ZM14 10C14 11.1046 13.1046 12 12 12V14C14.2091 14 16 12.2091 16 10H14ZM12 12C10.8954 12 10 11.1046 10 10H8C8 12.2091 9.79086 14 12 14V12ZM10 10C10 8.89543 10.8954 8 12 8V6C9.79086 6 8 7.79086 8 10H10ZM12 8C13.1046 8 14 8.89543 14 10H16C16 7.79086 14.2091 6 12 6V8ZM12 20C9.99966 20 8.173 19.2671 6.77004 18.0539L5.46183 19.5667C7.21436 21.0822 9.50126 22 12 22V20ZM6.77004 18.0539C5.07193 16.5855 4 14.4185 4 12H2C2 15.0236 3.34312 17.7345 5.46183 19.5667L6.77004 18.0539ZM20 12C20 14.4185 18.9281 16.5855 17.23 18.0539L18.5382 19.5667C20.6569 17.7345 22 15.0236 22 12H20ZM17.23 18.0539C15.827 19.2671 14.0003 20 12 20V22C14.4987 22 16.7856 21.0822 18.5382 19.5667L17.23 18.0539ZM7.23817 19.0287C8.37439 17.7854 10.0096 17 12 17V15C9.45012 15 7.27843 16.02 5.76183 17.6795L7.23817 19.0287ZM12 17C13.9904 17 15.6256 17.7854 16.7618 19.0287L18.2382 17.6795C16.7216 16.02 14.5499 15 12 15V17Z"
                  fill="currentColor"
                />
              </svg>
            </div>
            <p className="ml-16 text-sm font-medium text-gray-900 truncate">
              Mijn Profiel
            </p>
          </dt>
          <dd className="flex items-baseline pb-6 ml-16 sm:pb-7">
            <p className="text-sm text-gray-500">
              Klik hieronder om de gegevens van je profiel aan te passen.
            </p>
            <div className="absolute inset-x-0 bottom-0 px-4 py-4 bg-gray-50 sm:px-6">
              <div className="text-sm">
                <div className="font-medium text-primary group-hover:underline">
                  Profiel bewerken
                </div>
              </div>
            </div>
          </dd>
        </Link>
        <Link
          to="/company/"
          className="overflow-hidden relative px-4 pt-6 pb-12 bg-white border shadow-sm sm:px-6 sm:pt-7 group"
        >
          <dt>
            <div className="absolute p-3 rounded-full bg-primary/5">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                className="w-6 h-6 text-gray-400 size- shrink-0"
                viewBox="0 0 24 24"
                fill="none"
                className="text-primary size-6"
              >
                <path
                  d="M4 19H14M4 19V4H14V8M4 19H2M20 19H14M20 19V8H14M20 19H22M14 19V8M10 9H8M8 13H10"
                  stroke="currentColor"
                  strokeWidth="1.5"
                  strokeMiterlimit="16"
                  strokeLinecap="square"
                ></path>
              </svg>
            </div>
            <p className="ml-16 text-sm font-medium text-gray-900 truncate">
              Bedrijfsgegevens
            </p>
          </dt>
          <dd className="flex items-baseline pb-6 ml-16 sm:pb-7">
            <p className="text-sm text-gray-500">
              Klik hieronder om de gegevens van de gekoppelde bedrijven aan te
              passen.
            </p>
            <div className="absolute inset-x-0 bottom-0 px-4 py-4 bg-gray-50 sm:px-6">
              <div className="text-sm">
                <div className="font-medium text-primary group-hover:underline">
                  Bedrijven bewerken
                </div>
              </div>
            </div>
          </dd>
        </Link>
      </dl>
      <div className="divide-y divide-black/10">
        {getUser() && getUser().companies && getUser().companies.length > 0 && (
          <div className="grid grid-cols-1 gap-x-8 gap-y-10 py-16">
            <div>
              <h3 className="font-semibold text-gray-900 text-base/7">
                Gekoppelde bedrijven
              </h3>
              <p className="mt-1 max-w-2xl text-gray-500 text-sm/6">
                Bedrijven waaraan je account gekoppeld is.
              </p>
            </div>
            <RadioGroup
              value={getCompany()}
              onChange={(company) => changeCurrentCompany(company)}
              className="grid grid-cols-1 col-span-2 gap-x-4 gap-y-6 lg:grid-cols-2"
            >
              {getUser().companies.map((item) => (
                <Radio
                  key={item.id}
                  value={item}
                  aria-label={item.name}
                  className="group relative flex cursor-pointer border border-gray-300 bg-white p-4 shadow-sm focus:outline-none data-[focus]:border-primary data-[focus]:ring-2 data-[focus]:ring-primary"
                >
                  <span className="flex flex-1">
                    <span className="flex flex-col">
                      <span className="block text-sm font-medium text-gray-900">
                        {item.name}
                      </span>
                      {item.full_address && (
                        <span className="mt-1 text-sm text-gray-500">
                          {item.full_address}
                        </span>
                      )}
                      {(item.zipcode || item.residence) && (
                        <span className="mt-1 text-sm text-gray-500">
                          {item.zipcode} {item.residence}
                        </span>
                      )}
                      {item.email1 && (
                        <span className="mt-1 text-sm text-gray-500">
                          {item.email1}
                        </span>
                      )}
                    </span>
                  </span>
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    className="size-5 text-primary group-[&:not([data-checked])]:invisible"
                    viewBox="0 0 24 24"
                    fill="none"
                  >
                    <path
                      fill-rule="evenodd"
                      clip-rule="evenodd"
                      d="M12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2ZM16.0554 9.39446L14.8945 8.4446L10.4443 13.8837L8.5 11.9393L7.43934 13L10.5557 16.1163L16.0554 9.39446Z"
                      fill="currentColor"
                    />
                  </svg>

                  <span
                    aria-hidden="true"
                    className="pointer-events-none absolute -inset-px  border-2 border-transparent group-data-[focus]:border group-data-[checked]:border-primary"
                  />
                </Radio>
              ))}
            </RadioGroup>
          </div>
        )}
        <div className="grid grid-cols-1 gap-8 py-16">
          <div>
            <h3 className="font-semibold text-gray-900 text-base/7">
              Bedrijven koppelen of aanmaken
            </h3>
            <p className="mt-1 max-w-2xl text-gray-500 text-sm/6">
              Om advertenties te kunnen plaatsen moet je een bedrijf koppelen.
              Maak zelf een bedrijf aan of koppel met een bestaand bedrijf.
            </p>
          </div>
          <div className="flex gap-5">
            <Link to="/company/" className="btn-primary">
              Bedrijf toevoegen
            </Link>
            <Button
              onClick={(event) => addCompanyConnectCode(event)}
              className="btn-secondary"
            >
              Bedrijf koppelen
            </Button>
          </div>
        </div>
      </div>
    </>
  );
}
